var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3128 13.375H22.9066V9.15625C22.9066 4.29297 18.8636 0.25 14.0003 0.25C9.07845 0.25 5.09408 4.29297 5.09408 9.15625V13.375H3.68783C2.10579 13.375 0.875326 14.6641 0.875326 16.1875V27.4375C0.875326 29.0195 2.10579 30.25 3.68783 30.25H24.3128C25.8363 30.25 27.1253 29.0195 27.1253 27.4375V16.1875C27.1253 14.6641 25.8363 13.375 24.3128 13.375ZM18.2191 13.375H9.78158V9.15625C9.78158 6.87109 11.6566 4.9375 14.0003 4.9375C16.2855 4.9375 18.2191 6.87109 18.2191 9.15625V13.375Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4f753f16c23569c71d61469502e84f28.svg";
export { ForwardRef as ReactComponent };